<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-dialog v-model="dialogMap" @click:outside="closeDialogMapa">
            <v-card v-if="dialogMap" class="emb-map-dialog-root">
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogMapa">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $tc('relPlot.self', 1) }}</v-toolbar-title>
                </v-toolbar>

                <div class="emb-map-dialog-body">
                    <v-navigation-drawer
                        v-if="mapModoMultiplosEmbarques"
                        v-model="showingDrawerLinhasEmbMap"
                        absolute
                        temporary
                        left
                        overlay-opacity="0"
                        class="emb-map-linhas-drawer"
                    >
                        <div class="emb-map-linhas-drawer-inner">
                            <v-toolbar flat dense class="pr-0 emb-map-linhas-drawer-toolbar">
                                <div class="pl-2 d-flex align-center" style="min-width: 0;">
                                    <div class="subtitle-1 font-weight-medium text-truncate">
                                        {{ $t('relBoarding.mapLinesDrawerTitle') }}
                                    </div>
                                    <v-tooltip bottom max-width="280">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                icon
                                                x-small
                                                class="ml-1 flex-shrink-0"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon small color="grey darken-1">mdi-information-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('relBoarding.mapLinesDrawerHint') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-spacer />
                                <v-btn icon @click="showingDrawerLinhasEmbMap = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-divider />
                            <div class="px-3 pt-3 pb-2 emb-map-linhas-drawer-search">
                                <v-text-field
                                    v-model="mapDrawerLinhasSearch"
                                    prepend-inner-icon="mdi-magnify"
                                    clearable
                                    dense
                                    hide-details
                                    single-line
                                    :placeholder="$t('relBoarding.mapLinesDrawerSearchPlaceholder')"
                                />
                            </div>
                            <div class="px-2 pb-2 emb-map-linhas-drawer-actions">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                            <v-btn
                                                small
                                                block
                                                text
                                                :disabled="!mapRotas.length && !mapCercasGeojson.length && !mapCercasCirculares.length"
                                                @click="limparRotasCercasSomenteMapa"
                                            >
                                                <v-icon left small>mdi-layers-off</v-icon>
                                                {{ $t('relBoarding.clearRoutesCercasMap') }}
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>{{ $t('relBoarding.clearRoutesCercasMapTooltip') }}</span>
                                </v-tooltip>
                            </div>
                            <v-list
                                dense
                                class="emb-map-linhas-drawer-list pa-0"
                            >
                                <v-list-item
                                    v-for="(linha, i) in linhasDrawerMapaEmbarquesFiltradas"
                                    :key="`emb-map-linha-${linha.id_linha}-${i}`"
                                    class="text-left emb-map-linhas-drawer-list-item"
                                    @click="toggleLinhaMapaEmbarques(linha)"
                                    :style="selectedLinhaDrawerMapaEmbarquesStyle(linha)"
                                >
                                    <v-list-item-content class="py-2">
                                        <v-list-item-title class="d-flex align-center flex-wrap" style="gap: 6px;">
                                            <span class="font-weight-medium text-truncate mr-1">{{ linha.cod_linha }}</span>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="ma-0"
                                                        x-small
                                                        style="background-color: #2e7d32; color: white;"
                                                        @click.stop
                                                    >
                                                        {{ contagemDrawerLinha(linha.id_linha, 'auth') }}
                                                    </v-chip>
                                                </template>
                                                <span>{{ $t('relBoarding.mapChipTooltipAuthorized') }}</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="ma-0"
                                                        x-small
                                                        style="background-color: #f9a825; color: #1a1a1a;"
                                                        @click.stop
                                                    >
                                                        {{ contagemDrawerLinha(linha.id_linha, 'wrong') }}
                                                    </v-chip>
                                                </template>
                                                <span>{{ $t('relBoarding.mapChipTooltipWrongRoute') }}</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="ma-0"
                                                        x-small
                                                        style="background-color: #c62828; color: white;"
                                                        @click.stop
                                                    >
                                                        {{ contagemDrawerLinha(linha.id_linha, 'denied') }}
                                                    </v-chip>
                                                </template>
                                                <span>{{ $t('relBoarding.mapChipTooltipNotAuthorized') }}</span>
                                            </v-tooltip>
                                            <v-spacer />
                                            <v-progress-circular
                                                v-if="mapLinhaToggleLoadingId === linha.id_linha"
                                                indeterminate
                                                size="20"
                                                width="2"
                                                color="primary"
                                                class="flex-shrink-0"
                                            />
                                        </v-list-item-title>
                                        <v-list-item-subtitle
                                            v-if="linha.nome_linha"
                                            class="text-wrap mt-1"
                                            :style="selectedLinhaDrawerMapaEmbarquesSubtitleStyle(linha)"
                                        >
                                            {{ linha.nome_linha }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </div>
                    </v-navigation-drawer>

                    <v-overlay
                        :value="exportingMapPdf"
                        absolute
                        opacity="0.55"
                        z-index="6000"
                    >
                        <div class="text-center white--text px-4">
                            <v-progress-circular indeterminate color="white" class="mb-3" />
                            <div>{{ $t('operation.exportingPdfWait') }}</div>
                        </div>
                    </v-overlay>
                    <v-card-text class="emb-map-dialog-card-text pt-4">
                    <div ref="plotagempdfdiv" style="width: 100%; height: 75vh;">
                        <l-map ref="mapPlotagem" :key="embMapLeafletKey" :zoom="zoom" :center="currentCenter"
                            @ready="onMapPlotagemReady" :options="mapOptions"
                            v-resize="onMapPlotagemResize" style="border-radius: 10px; margin-top: 5px; z-index: 1">
                            <l-tile-layer :url="url" :attribution="attribution" />

                            <l-control v-if="mapModoMultiplosEmbarques" position="topleft">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            small
                                            fab
                                            color="primary"
                                            class="mb-1"
                                            v-on="on"
                                            @click="toggleDrawerLinhasEmbMap"
                                        >
                                            <v-icon color="white">mdi-chevron-right</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('relBoarding.mapLinesDrawerTooltip') }}</span>
                                </v-tooltip>
                            </l-control>

                            <l-marker v-for="(reg, k) in mapEmbarqueMarkers" :key="`emb-${reg.id_embarque}-${k}`"
                                :lat-lng="latLng(reg.lat, reg.lng)" :visible="markerEmbarqueVisible"
                                :icon="getIconEmbarqueMapa(reg)" :zIndexOffset="20">
                                <l-popup>
                                    <span>{{ reg.cod_veiculo }}</span>
                                    <br />
                                    <span>{{ reg.dt_embarque_extenso }}</span>
                                    <br />
                                    <span v-if="reg.nome_cerca || reg.cod_cerca">
                                        {{ $t('relBoarding.parada') }}:
                                        <template
                                            v-if="reg.nome_cerca && reg.cod_cerca && String(reg.nome_cerca).trim() !== String(reg.cod_cerca).trim()"
                                        >
                                            {{ reg.nome_cerca }} ({{ reg.cod_cerca }})
                                        </template>
                                        <template v-else>{{ reg.nome_cerca || reg.cod_cerca }}</template>
                                    </span>
                                    <br v-if="reg.nome_cerca || reg.cod_cerca" />
                                    <span>{{ `${$t('relMaintenence.headerPositions.lat')}: ${reg.lat}` }}</span>
                                    <br />
                                    <span>{{ `${$t('relMaintenence.headerPositions.lng')}: ${reg.lng}` }}</span>
                                    <br />
                                    <span>{{ `${$tc('passenger.self', 1)}: ${reg.nome_completo}` }}</span>
                                    <br />
                                    <span v-if="reg.cod_linha_veiculo">{{ `${$tc('line.self', 1)}: ${reg.cod_linha_veiculo}` }}</span>
                                    <br v-if="Number(reg.sem_posicoes_janela) === 1" />
                                    <span v-if="Number(reg.sem_posicoes_janela) === 1" class="orange--text text--darken-2">
                                        <v-icon x-small color="orange darken-2" class="mr-1">mdi-alert</v-icon>
                                        {{ $t('relBoarding.noPositionsTooltip') }}
                                    </span>
                                </l-popup>
                            </l-marker>

                            <l-geo-json
                                v-for="(rota, i) in mapRotas"
                                :key="`rota-emb-${rota._idLinhaMapaEmbarque}-${rota.id_rota}-${i}`"
                                :geojson="rota.geojson"
                                :options-style="rota.style"
                                :options="rota.options"
                                :visible="rotasMapaVisible"
                            />
                            <l-geo-json
                                v-for="(cerca, w) in mapCercasGeojson"
                                :key="`cerca-emb-${cerca._idLinhaMapaEmbarque}-${cerca.id_cerca}-${w}`"
                                :geojson="cerca.geojson"
                                :options="cerca.options"
                                :options-style="cerca.style"
                                :visible="cercasMapaVisible"
                            />
                            <l-circle
                                v-for="(cerca, w) in mapCercasCirculares"
                                :key="`cerca-circ-${cerca._idLinhaMapaEmbarque}-${cerca.id_cerca}-${w}`"
                                :lat-lng="latLng(cerca.lat_centro, cerca.lng_centro)"
                                :radius="Number(cerca.raio_mts) || 0"
                                :color="cerca._strokeColor"
                                :fill-color="cerca._fillColor"
                                :fill-opacity="0.25"
                                :weight="2"
                                :visible="cercasMapaVisible"
                            >
                                <l-tooltip v-if="cerca.nome_cerca" :content="cerca.nome_cerca" />
                            </l-circle>

                            <l-control :position="'topright'" class="text-overlay">
                                <v-row>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on">
                                                    <v-checkbox
                                                        v-model="rotasMapaVisible"
                                                        hide-details
                                                        dense
                                                        :label="$tc('operation.route', 1)"
                                                    />
                                                </div>
                                            </template>
                                            <span>{{ $t('relBoarding.mapCheckboxRoutesTooltip') }}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on">
                                                    <v-checkbox
                                                        v-model="cercasMapaVisible"
                                                        hide-details
                                                        dense
                                                        :label="$t('relBoarding.parada')"
                                                    />
                                                </div>
                                            </template>
                                            <span>{{ $t('relBoarding.mapCheckboxCercasTooltip') }}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on">
                                                    <v-checkbox
                                                        v-model="markerEmbarqueVisible"
                                                        hide-details
                                                        dense
                                                        :label="$t('relBoarding.title')"
                                                    />
                                                </div>
                                            </template>
                                            <span>{{ $t('relBoarding.mapCheckboxEmbarquesTooltip') }}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </l-control>

                            <l-control :position="'topright'" class="emb-map-pdf-hide">
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            fab
                                            :disabled="exportingMapPdf"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="exportPDF($refs.plotagempdfdiv)"
                                        >
                                            <v-icon color="black">mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('detalhesViagem.map.exportPdf') }}</span>
                                </v-tooltip>
                            </l-control>
                        </l-map>
                    </div>
                    </v-card-text>
                </div>
            </v-card>

        </v-dialog>

        <v-dialog v-model="dialogReprocessamento" max-width="560">
            <v-card>
                <v-card-title>{{ $t('relBoarding.reprocess.title') }}</v-card-title>
                <v-card-text class="text-left">
                    <p>{{ $t('relBoarding.reprocess.confirm', reprocessamentoPeriodo) }}</p>
                    <p>
                        {{ resumoFiltrosReprocessamento
                            ? $t('relBoarding.reprocess.filters', { filtros: resumoFiltrosReprocessamento })
                            : $t('relBoarding.reprocess.noFilters') }}
                    </p>
                    <p class="mb-0 caption">{{ $t('relBoarding.reprocess.hint') }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogReprocessamento = false">{{ $t('button.cancel') }}</v-btn>
                    <v-btn color="primary" @click="confirmarReprocessamento">{{ $t('relBoarding.reprocess.start') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <!-- <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                    v-model="idEmpresaSelected"
                    :items="empresas"
                    item-text="razao_social"
                    item-value="id_empresa"
                    clearable
                    label="Empresa"
                    :rules="[(v) => !!v || 'Selecione uma empresa']"
                    @change="onEmpresaChanged"
                ></v-autocomplete>
            </v-col> -->
                    <!-- <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                    v-model="idClienteSelected"
                    :items="clientesSelect"
                    item-text="nome_cliente"
                    item-value="id_cliente"
                    clearable
                    label="Cliente"
                    @change="onClienteChanged"
                ></v-autocomplete>
            </v-col> -->
                    <v-col cols="12" sm="6" md="2">
                        <MultiplaEscolha
                            ref="linhasSelectRef"
                            lazy
                            get-url="getLinhaslazy"
                            :request-data="lazySelectRequestData"
                            text="cod_linha"
                            value="id_linha"
                            v-bind:selected-items.sync="idLinhaSelected"
                            :label="$tc('line.self', 1)"
                            :max-items="3"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha
                            ref="unidadesSelectRef"
                            lazy
                            get-url="getUnidadeslazy"
                            :items="semUnidadeOption"
                            text="descricao_unidade"
                            value="id_unidade"
                            v-bind:selected-items.sync="unidadesSelecionadas"
                            :label="$t('nav.registration.units')"
                            :max-items="2"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <MultiplaEscolha
                            ref="veiculosSelectRef"
                            lazy
                            get-url="getVeiculoslazy"
                            :request-data="lazySelectRequestData"
                            text="cod_veiculo"
                            value="id_veiculo"
                            v-bind:selected-items.sync="idVeiculoSelected"
                            :label="$tc('vehicle.self', 1)"
                            :max-items="3"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha
                            ref="passageirosSelectRef"
                            lazy
                            get-url="getPessoaslazy"
                            :request-data="lazySelectRequestData"
                            text="nome_completo"
                            value="id_pessoa"
                            v-bind:selected-items.sync="idPassageiroSelected"
                            :label="$tc('passenger.self', 1)"
                            :max-items="2"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="2" align="center" style="align-self: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="setDefaultFilters" style="margin-left: 10px; margin-bottom: 5px;">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.newConsult') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf"
                            :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-switch v-model="mostrarAutorizados" color="primary" :label="$t('relBoarding.authorized')"
                            :disabled="mostrarAutorizados && !mostrarRecusados && !mostrarRotaErrada"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-switch v-model="mostrarRecusados" color="primary" :label="$t('dashboard.denied')"
                            :disabled="!mostrarAutorizados && mostrarRecusados && !mostrarRotaErrada"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-switch v-model="mostrarRotaErrada" color="primary" :label="$t('dashboard.routeError')"
                            :disabled="!mostrarAutorizados && !mostrarRecusados && mostrarRotaErrada"></v-switch>
                    </v-col>
                </v-row>
                <!-- <v-row>
            <v-col cols="12" sm="6" md="5">
                <v-autocomplete
                    v-model="idVeiculosSelected"
                    :items="veiculosSelect"
                    item-text="numero_ordem"
                    item-value="id_veiculo"
                    multiple
                    clearable
                    label="Veículo"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="5">
                <v-autocomplete
                    v-model="idCercasSelected"
                    :items="cercas"
                    item-text="endereco"
                    item-value="id_cerca"
                    multiple
                    clearable
                    label="Cerca"
                ></v-autocomplete>
            </v-col>
        </v-row> -->
            </v-form>
        </v-container>

      <merus-data-table
        ref="reportsTable"
        :headers="headers"
        :items="reports"
        item-key="id_embarque"
        :loading="loading"
        :default-multi-sort="defaultSort"
        :server-items-length="totalEmbarques"
        :items-per-page="numberOfRows"
        :items-per-page-last-option="itemsPerPageLastOption"
        :server-sort-by="serverSortBy"
        :server-sort-desc="serverSortDesc"
        dense
        class="elevation-7"
        locale="pt"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-top: 10px;"
        cod-tabela="RELEMBARQUES"
        append-actions
        actions-i18n-key="system.labels.actions"
        @update:headers="headers = $event"
        @update:options="onTableOptions"
        @update:filters="onFiltersUpdate">
        
          <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('relBoarding.title')"
                :token="token"
                :items="reports"
                csv-title="relembarques"
                :csv-headers="exportHeadersResolved"
                list-endpoint="getallembarquesdata"
                :load-items-for-export="loadItemsForExport"
                background-export
                :export-filters="exportFiltersForCsv"
                :export-sort-by="serverSortBy"
                :export-sort-desc="serverSortDesc"
                :export-total="totalEmbarques"
                id-field="id_embarque"
                :pdf-title="$t('relBoarding.title')"
                :pdf-headers="exportHeadersResolved"
                pdf-filename="relembarques"
                hide-search
                @export-loading="onExportLoading"
            >
                <template v-slot:add>
                    <v-tooltip v-if="podeReprocessar" top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                dark
                                small
                                class="mb-2 mr-2"
                                fab
                                :loading="reprocessando"
                                :disabled="reprocessando"
                                @click="abrirReprocessamento"
                            >
                                <v-icon>mdi-database-refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ reprocessando ? $t('relBoarding.reprocess.running') : $t('relBoarding.reprocess.tooltip') }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                dark
                                small
                                class="mb-2 mr-2"
                                fab
                                :disabled="!temEmbarquePlotavelNoFiltro"
                                @click="plotTodosFiltrados"
                            >
                                <v-icon>mdi-map-marker-multiple</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('relBoarding.plotAllTooltip') }}</span>
                    </v-tooltip>
                </template>
            </CadastroToolbar>
        </template>

            <template v-slot:item.autorizado_extenso="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    :color="item.autorizado == 1 ? 'green' : item.autorizado == 2 ? 'orange' : 'red'"
                    :title="item.autorizado == 1
                        ? $t('relBoarding.authorized')
                        : item.autorizado == 2
                            ? $t('dashboard.routeError')
                            : $t('dashboard.denied')"
                >mdi-circle</v-icon>
            </template>

            <template v-slot:item.sem_posicoes_janela="{ item }">
                <v-icon
                    v-if="Number(item.sem_posicoes_janela) === 1"
                    small
                    color="orange darken-2"
                    :title="$t('relBoarding.noPositionsTooltip')"
                >mdi-alert</v-icon>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="blue" @click="plot(item)"
                    :disabled="!embarqueTemCoordenada(item)">mdi-map-marker</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import L from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
    LCircle,
    LGeoJson,
    LTooltip
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import DateUtils from "../utils/dateutils";
import { mdiAccount } from "@mdi/js";
import serverTableMixin from "@/mixins/serverTableMixin";
import {
    buildRequestParams,
    computePageState,
    initSortFromDefault,
    samePageAndSort,
    fetchAllServerPagesForExport,
} from "@/utils/serverTablePagination";

/** Período máximo do reprocessamento; mesmo limite de api/routers/embarques/reprocessaembarques.js. */
const MAX_HORAS_REPROCESSAMENTO = 24;
const ROTA_REPROCESSAMENTO = "/api/v1.0/reprocessaembarques";
const REPROCESSAMENTO_POLL_MS = 5000;
const REPROCESSAMENTO_TIMEOUT_MS = 30 * 60 * 1000;
/** Sem a rotina SCHEDULER ligada o processo nunca sai de PENDING. */
const REPROCESSAMENTO_PENDING_TIMEOUT_MS = 3 * 60 * 1000;
const DATA_SQL_RE = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/;

export default {
    mixins: [serverTableMixin],
    components: {
        MerusDataTable,
        CadastroToolbar,
        MultiplaEscolha,
        LMap,
        LTileLayer,
        LMarker,
        LControl,
        LPopup,
        LCircle,
        LGeoJson,
        LTooltip,
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        showMapa: false,
        recursos: [],
        veiculosSelect: [],
        cercas: [],
        empresas: [],
        linhas: [],
        idLinhaSelected: [],
        idVeiculoSelected: [],
        reports: [],
        dti: null,
        dtf: null,
        idEmpresaSelected: null,
        idVeiculosSelected: [],
        idCercasSelected: [],
        loadingtable: false,
        loadingExport: false,
        timeProps: {
            useSeconds: true,
        },
        formValidado: false,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        zoom: 12,
        currentCenter: null,
        /** Alterna 0/1 a cada abertura para remontar o mapa (evita centro antigo do Leaflet). */
        embMapLeafletKey: 0,
        mapOptions: {
            zoomSnap: 0.5,
            zoomAnimation: false,
            fadeAnimation: false,
            markerZoomAnimation: false,
        },
        mapEmbarqueMarkers: [],
        mapEmbarqueMarkersOriginais: [],
        mapRotas: [],
        mapCercasGeojson: [],
        mapCercasCirculares: [],
        rotasMapaVisible: true,
        cercasMapaVisible: true,
        markerEmbarqueVisible: true,
        mapModoMultiplosEmbarques: false,
        showingDrawerLinhasEmbMap: false,
        mapDrawerLinhasSearch: "",
        mapLinhasPlotadasNoMapa: [],
        mapLinhaToggleLoadingId: null,
        map: null,
        dialogMap: false,
        exportingMapPdf: false,
        clientes: [],
        clientesSelect: [],
        idClienteSelected: null,
        idPassageiroSelected: [],
        unidadesSelecionadas: [],
        mostrarAutorizados: true,
        mostrarRecusados: true,
        mostrarRotaErrada: true,
        config: null,
        totalEmbarques: 0,
        numberOfRows: 10,
        itemsPerPageLastOption: 250,
        lastItemsPerPageBeforeTodos: null,
        pageNumber: 1,
        serverSortBy: [],
        serverSortDesc: [],
        searchFilters: {},
        baseFilters: {},
        columnFilters: {},
        hasLoadedReport: false,
        dialogReprocessamento: false,
        reprocessamentoFiltros: null,
        reprocessando: false,
        reprocessamentoPollTimer: null,
        reprocessamentoPollInFlight: false,
    }),
    watch: {
        '$i18n.locale'() {
            this.initialize();
            this.headers = this.defaultHeaders;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        /** Fecha via ESC/overlay: limpa estado e libera DOM do Leaflet (v-if no card). */
        dialogMap(open) {
            if (!open) {
                this.resetEstadoMapaEmbarque();
            }
        },
        mostrarAutorizados() {
            this.onStatusFilterChange();
        },
        mostrarRecusados() {
            this.onStatusFilterChange();
        },
        mostrarRotaErrada() {
            this.onStatusFilterChange();
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        /** Cache de L.divIcon por status (1 / 2 / other) — não reativo. */
        this._mapIconByAutorizado = Object.create(null);
        this.headers = this.defaultHeaders;
        this.initialize();
    },
    beforeDestroy() {
        this.clearReprocessamentoPoll();
    },
    computed: {
        /** Superadmin ou quem tem o endpoint (TELA_..._UPDATE do relatório ou concessão direta). */
        podeReprocessar() {
            if (this.user && this.user.is_superadmin === 1) return true;
            return (this.recursos || []).some((r) => r && r.rota === ROTA_REPROCESSAMENTO);
        },
        reprocessamentoPeriodo() {
            const f = this.reprocessamentoFiltros || {};
            return {
                dti: this.formatarDataSql(f.dti),
                dtf: this.formatarDataSql(f.dtf),
            };
        },
        resumoFiltrosReprocessamento() {
            const f = this.reprocessamentoFiltros || {};
            return [
                [this.$tc('line.self', 2), f.id_linha],
                [this.$t('nav.registration.units'), f.id_unidade],
                [this.$tc('vehicle.self', 2), f.id_veiculo],
                [this.$tc('passenger.self', 2), f.id_pessoa],
            ]
                .filter(([, ids]) => ids && ids.length)
                .map(([rotulo, ids]) => `${rotulo}: ${ids.length}`)
                .join(' · ');
        },
        center() {
            return this.$store.getters['config/centerDefault'];
        },
        loading() {
            return this.loadingtable || this.loadingExport;
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            }
        },
        defaultSort() {
            return [
                {
                    value: 'dt_embarque_extenso',
                    options: { text: this.$t('system.labels.decreasing'), value: -1 },
                },
            ];
        },
        exportFiltersForCsv() {
            return this.getMergedFilters();
        },
        /** Fallback quando tabelas_front/RELEMBARQUES não está configurado no banco. */
        defaultHeaders() {
            return [
                { text: this.$t('datetime.date'), value: 'data_embarque' },
                { text: this.$t('datetime.time'), value: 'hora_embarque' },
                { text: this.$t('passengers.personal.registrationCode'), value: 'matricula' },
                { text: this.$tc('passenger.self', 1), value: 'nome_completo' },
                { text: this.$t('passengers.personal.leader'), value: 'lider' },
                { text: this.$t('relBoarding.parada'), value: 'cod_cerca' },
                { text: this.$tc('line.self', 1), value: 'cod_linha_veiculo' },
                { text: this.$t('relBoarding.header.group'), value: 'nome_grupo' },
                { text: this.$tc('vehicle.self', 1), value: 'numero_ordem' },
                { text: this.$tc('crudQuadros.headers.trips.departureTime'), value: 'horario_saida_viagem_extenso' },
                { text: this.$tc('crudQuadros.headers.trips.arrivalTime'), value: 'horario_chegada_viagem_extenso' },
                { text: this.$tc('crudQuadros.headers.trips.direction'), value: 'descricao_sentido_viagem' },
                { text: this.$tc('crudQuadros.headers.trips.shift'), value: 'descricao_turno_viagem' },
                { text: this.$t('vehicleAuthorization.headers.authorized'), value: 'autorizado_extenso', align: 'center' },
                { text: this.$t('relBoarding.header.alerts'), value: 'sem_posicoes_janela', align: 'center' },
                { text: this.$t('vehicleAuthorization.headers.actions'), value: 'actions', sortable: false },
            ];
        },
        /** Headers efetivos para CSV/PDF (fallback se a tabela ainda não emitiu colunas). */
        exportHeadersResolved() {
            return (this.headers && this.headers.length)
                ? this.headers
                : this.defaultHeaders;
        },
        headersWithProperties() {
            return this.headers.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        semUnidadeOption() {
            return [
                {
                    id_unidade: -1,
                    descricao_unidade: 'Sem Unidade',
                    cod_unidade: 'SU',
                },
            ];
        },
        lazySelectRequestData() {
            const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
            const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
            const temSemUnidade = unidades.includes(-1);
            if (reais.length === 1 && !temSemUnidade) {
                return { id_unidade: reais[0] };
            }
            if (temSemUnidade && reais.length === 0) {
                return { id_unidade: -1 };
            }
            return {};
        },
        linhasFiltradasPorUnidade() {
            return (this.linhas || []).filter((l) => this.passaFiltroUnidades(l));
        },
        temEmbarquePlotavelNoFiltro() {
            return this.hasLoadedReport && this.totalEmbarques > 0;
        },
        /**
         * Linhas que têm pelo menos um embarque na plotagem atual (marcadores no mapa),
         * enriquecidas com cadastro quando existir; busca e ordenação por código.
         */
        linhasDrawerMapaEmbarquesFiltradas() {
            const markers = this.mapEmbarqueMarkersOriginais || [];
            const firstByLinha = new Map();
            markers.forEach((m) => {
                if (m.id_linha == null) return;
                const id = Number(m.id_linha);
                if (!id || Number.isNaN(id)) return;
                if (!firstByLinha.has(id)) firstByLinha.set(id, m);
            });
            const linhasById = new Map(
                (this.linhasFiltradasPorUnidade || []).map((l) => [Number(l.id_linha), l])
            );
            const list = [];
            firstByLinha.forEach((sampleMarker, id) => {
                let linha = linhasById.get(id);
                if (!linha) {
                    linha = {
                        id_linha: id,
                        cod_linha:
                            (sampleMarker.cod_linha_veiculo &&
                                String(sampleMarker.cod_linha_veiculo).trim()) ||
                            `id ${id}`,
                        nome_linha: null,
                    };
                }
                list.push(linha);
            });
            const q = (this.mapDrawerLinhasSearch || "").trim().toLowerCase();
            let filtered = list;
            if (q) {
                filtered = list.filter((l) => {
                    const cod = String(l.cod_linha || "").toLowerCase();
                    const nome = String(l.nome_linha || l.descricao_linha || "").toLowerCase();
                    const razao = String(l.razao_social || "").toLowerCase();
                    return cod.includes(q) || nome.includes(q) || razao.includes(q);
                });
            }
            return filtered.sort((a, b) =>
                String(a.cod_linha || "").localeCompare(String(b.cod_linha || ""), undefined, {
                    numeric: true,
                    sensitivity: "base",
                })
            );
        },
        /**
         * Contagens do drawer: um passe sobre os marcadores da plotagem "todos".
         * Chave = id_linha; valores = { auth, wrong, denied }.
         */
        contagensEmbarquesMapaPorLinha() {
            const fonte =
                this.mapModoMultiplosEmbarques &&
                (this.mapEmbarqueMarkersOriginais || []).length
                    ? this.mapEmbarqueMarkersOriginais
                    : this.mapEmbarqueMarkers;
            const counts = Object.create(null);
            (fonte || []).forEach((m) => {
                if (m.id_linha == null) return;
                const id = Number(m.id_linha);
                if (!id || Number.isNaN(id)) return;
                let bucket = counts[id];
                if (!bucket) {
                    bucket = { auth: 0, wrong: 0, denied: 0 };
                    counts[id] = bucket;
                }
                const a = Number(m.autorizado);
                if (a === 1) bucket.auth += 1;
                else if (a === 2) bucket.wrong += 1;
                else bucket.denied += 1;
            });
            return counts;
        },
    },
    methods: {
        idsUnidadesNoObjeto(o) {
            if (Array.isArray(o.unidades) && o.unidades.length) {
                return o.unidades.map((id) => Number(id));
            }
            if (o.id_unidade != null && o.id_unidade !== "") {
                return [Number(o.id_unidade)];
            }
            return [];
        },
        passaFiltroUnidades(o) {
            if (this.unidadesSelecionadas.length === 0) {
                return true;
            }
            const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
            const rowUnidades = this.idsUnidadesNoObjeto(o);
            const semUnidadeSelected = selecionadas.includes(-1);
            const objetoSemUnidade = rowUnidades.length === 0 || rowUnidades.includes(-1);
            const matchesUnidade = selecionadas.some(
                (sid) => sid !== -1 && rowUnidades.includes(sid)
            );
            return matchesUnidade || (semUnidadeSelected && objetoSemUnidade);
        },
        statusFilterFields() {
            return {
                status_autorizado: this.mostrarAutorizados ? 1 : 0,
                status_recusado: this.mostrarRecusados ? 1 : 0,
                status_rota_errada: this.mostrarRotaErrada ? 1 : 0,
            };
        },
        onStatusFilterChange() {
            if (!this.hasLoadedReport) return;
            this.baseFilters = {
                ...this.baseFilters,
                ...this.statusFilterFields(),
            };
            this.pageNumber = 1;
            this.serverTableLoad();
        },
        onExportLoading(payload) {
            if (!payload || typeof payload !== 'object') return;
            this.loadingExport = !!payload.loading;
        },
        initialize() {
            this.currentCenter = this.center;
            if (
                this.serverSortBy.length === 0 &&
                this.defaultSort &&
                this.defaultSort.length > 0
            ) {
                const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
                this.serverSortBy = serverSortBy;
                this.serverSortDesc = serverSortDesc;
            }
            this.getConfig();
            this.populaRecursos();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                },
            });
        },
        populaRecursos() {
            if (this.user && this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaCercas();
                        this.populaClientes();
                        this.populaLinhas();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user && this.user.id_usuario },
                    silent: true,
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaCercas();
                        this.populaClientes();
                        this.populaLinhas();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                        if (e.message == "Request failed with status code 401") {
                            this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                            this.autorizacaoDialog = true;
                        }
                    },
                });
            }
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                silent: true,
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                silent: true,
                onSuccess: (response) => {
                    this.linhas = response.data || [];
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaCercas() {
            apiController.request(apiController.endpoints.getallCercasativas, {
                silent: true,
                onSuccess: (response) => {
                    this.cercas = response.data;
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaClientes() {
            apiController.request(apiController.endpoints.getallClientes, {
                onSuccess: (response) => {
                    this.clientes = response.data;
                },
            });
        },
        buildBaseFiltersFromForm() {
            const filters = {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf),
                ...this.statusFilterFields(),
            };
            // Seleção vazia = sem filtro: o recorte por cliente/unidade do usuário é
            // aplicado no SQL (escopoCliente), nunca resolvendo ids no front.
            if (this.idPassageiroSelected && this.idPassageiroSelected.length) {
                filters.id_pessoa = this.idPassageiroSelected.slice();
            }
            if (this.idVeiculoSelected && this.idVeiculoSelected.length) {
                filters.id_veiculo = this.idVeiculoSelected.slice();
            }
            if (this.idLinhaSelected && this.idLinhaSelected.length) {
                filters.id_linha = this.idLinhaSelected.slice();
            }
            if (this.unidadesSelecionadas && this.unidadesSelecionadas.length) {
                filters.id_unidade = this.unidadesSelecionadas.map((id) => Number(id));
            }
            return filters;
        },
        getMergedFilters() {
            return {
                ...this.baseFilters,
                ...this.columnFilters,
            };
        },
        onTableOptions(opts) {
            if (!this.hasLoadedReport || this.loadingtable) return;
            if (!opts) {
                this.serverTableLoad(opts);
                return;
            }
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
            };
            if (samePageAndSort(opts, state) && !this.loadingtable) {
                return;
            }
            this.serverTableLoad(opts);
        },
        onFiltersUpdate(filters) {
            if (!this.hasLoadedReport) return;
            const next = filters || {};
            if (JSON.stringify(next) === JSON.stringify(this.columnFilters)) return;
            this.columnFilters = next;
            this.pageNumber = 1;
            this.serverTableLoad();
        },
        serverTableLoad(options) {
            const mergedFilters = this.getMergedFilters();
            this.searchFilters = mergedFilters;
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
                searchFilters: mergedFilters,
                lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
                total: this.totalEmbarques,
            };
            const { params, page, rowsPerPage, sortByArr, sortDescArr } =
                buildRequestParams(options, state);
            this.loadingtable = true;
            apiController.request(apiController.endpoints.getallEmbarquesdata, {
                data: params,
                onSuccess: (response) => {
                    const data = response.data;
                    if (
                        data &&
                        typeof data.total === 'number' &&
                        Array.isArray(data.items)
                    ) {
                        this.reports = data.items.map((row) =>
                            row && typeof row === 'object' ? Object.freeze(row) : row
                        );
                        const updates = computePageState(
                            data,
                            { page, rowsPerPage, sortByArr, sortDescArr },
                            state,
                            this.itemsPerPageLastOption
                        );
                        this.totalEmbarques = updates.total;
                        this.pageNumber = updates.pageNumber;
                        this.numberOfRows = updates.numberOfRows;
                        this.lastItemsPerPageBeforeTodos =
                            updates.lastItemsPerPageBeforeTodos;
                        this.serverSortBy = updates.serverSortBy;
                        this.serverSortDesc = updates.serverSortDesc;
                    } else if (data && Array.isArray(data.dados)) {
                        this.reports = data.dados.map((row) =>
                            row && typeof row === 'object' ? Object.freeze(row) : row
                        );
                        this.totalEmbarques = this.reports.length;
                    } else {
                        this.reports = Array.isArray(data) ? data : [];
                        this.totalEmbarques = this.reports.length;
                    }
                    this.loadingtable = false;
                },
                onError: (e) => {
                    this.loadingtable = false;
                    EventBus.$emit('show-error', { error: e });
                },
            });
        },
        async loadItemsForExport(onProgress) {
            if (!this.hasLoadedReport) {
                return [];
            }
            return fetchAllServerPagesForExport({
                fetchPage: async (params) => {
                    const response = await apiController.request(
                        apiController.endpoints.getallEmbarquesdata,
                        { data: params, silent: true }
                    );
                    return response && response.data;
                },
                state: {
                    total: this.totalEmbarques,
                    serverSortBy: this.serverSortBy,
                    serverSortDesc: this.serverSortDesc,
                    searchFilters: this.getMergedFilters(),
                },
                onProgress,
            });
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (!this.formValidado) {
                return;
            }
            this.baseFilters = this.buildBaseFiltersFromForm();
            this.pageNumber = 1;
            this.hasLoadedReport = true;
            this.serverTableLoad();
        },
        setDefaultFilters() {
            let today = new Date();
            this.dti = today.toLocaleString().substring(0, 10) + " 00:00:00";
            this.dtf = today.toLocaleString().substring(0, 10) + " 23:59:59";
            this.idVeiculosSelected = [];
            this.idEmpresaSelected = null;
            this.veiculosSelect = [];
            this.idLinhaSelected = [];
            this.idVeiculoSelected = [];
            this.idPassageiroSelected = [];
            this.unidadesSelecionadas = [];
            this.reports = [];
            this.totalEmbarques = 0;
            this.hasLoadedReport = false;
            this.baseFilters = {};
            this.columnFilters = {};
            this.searchFilters = {};
            this.pageNumber = 1;
            ['linhasSelectRef', 'unidadesSelectRef', 'veiculosSelectRef', 'passageirosSelectRef'].forEach((refName) => {
                const ref = this.$refs[refName];
                if (ref && typeof ref.resetData === 'function') {
                    ref.resetData();
                }
            });
        },
        /** 'YYYY-MM-DD[T ]HH:MM:SS' → epoch (ms, horário local da data, só para comparar). */
        msDataSql(sql) {
            const m = DATA_SQL_RE.exec(String(sql || ''));
            return m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]).getTime() : NaN;
        },
        formatarDataSql(sql) {
            const m = DATA_SQL_RE.exec(String(sql || ''));
            return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}:${m[6]}` : '';
        },
        alertaReprocessamento(mensagem, tipo) {
            EventBus.$emit("show-alert", { mensagem, tipo, duracao: 6000 });
        },
        /** Período e filtros do formulário (o que está na tela), sem os switches de autorização. */
        abrirReprocessamento() {
            this.$refs.form.validate();
            if (!this.formValidado || this.reprocessando) return;
            const filtros = this.buildBaseFiltersFromForm();
            Object.keys(this.statusFilterFields()).forEach((k) => delete filtros[k]);
            const dti = this.msDataSql(filtros.dti);
            const dtf = this.msDataSql(filtros.dtf);
            if (!Number.isFinite(dti) || !Number.isFinite(dtf) || dtf < dti) {
                this.alertaReprocessamento(this.$t('relBoarding.reprocess.invalidPeriod'), 'warning');
                return;
            }
            if (dtf - dti > MAX_HORAS_REPROCESSAMENTO * 3600 * 1000) {
                this.alertaReprocessamento(
                    this.$t('relBoarding.reprocess.periodTooLong', { horas: MAX_HORAS_REPROCESSAMENTO }),
                    'warning'
                );
                return;
            }
            this.reprocessamentoFiltros = filtros;
            this.dialogReprocessamento = true;
        },
        async confirmarReprocessamento() {
            this.dialogReprocessamento = false;
            if (!this.reprocessamentoFiltros || this.reprocessando) return;
            this.reprocessando = true;
            let idProcesso = null;
            try {
                const res = await apiController.request(apiController.endpoints.reprocessaembarques, {
                    data: this.reprocessamentoFiltros,
                    silent: true,
                });
                idProcesso = res.data && res.data.id_processo;
            } catch (e) {
                const data = (e.response && e.response.data) || {};
                // 409: já há um em andamento — acompanha o que está rodando.
                if (e.response && e.response.status === 409 && data.id_processo) {
                    this.alertaReprocessamento(data.mensagem || this.$t('relBoarding.reprocess.running'), 'info');
                    this.pollReprocessamento(data.id_processo);
                    return;
                }
                this.falhaReprocessamento(data.mensagem);
                return;
            }
            if (!idProcesso) {
                this.falhaReprocessamento();
                return;
            }
            this.alertaReprocessamento(this.$t('relBoarding.reprocess.queued'), 'info');
            this.pollReprocessamento(idProcesso);
        },
        clearReprocessamentoPoll() {
            if (this.reprocessamentoPollTimer != null) clearInterval(this.reprocessamentoPollTimer);
            this.reprocessamentoPollTimer = null;
            this.reprocessamentoPollInFlight = false;
        },
        falhaReprocessamento(mensagem) {
            this.clearReprocessamentoPoll();
            this.reprocessando = false;
            this.alertaReprocessamento(mensagem || this.$t('relBoarding.reprocess.error'), 'error');
        },
        mensagemFalhaSchedulerReprocessamento(processo) {
            const chave = processo && processo.mensagem_scheduler;
            if (chave === 'MSG_BLOQUEIO_ALLOWLIST') return this.$t('relBoarding.reprocess.blocked');
            if (chave === 'MSG_INTERRUPCAO_SIGTERM' || chave === 'MSG_INTERRUPCAO_SIGTERM_FALHOU') {
                return this.$t('relBoarding.reprocess.interrupted');
            }
            return this.$t('relBoarding.reprocess.error');
        },
        concluiReprocessamento(resultado) {
            this.clearReprocessamentoPoll();
            this.reprocessando = false;
            if (resultado && resultado.erro) {
                this.falhaReprocessamento();
                return;
            }
            this.alertaReprocessamento(
                this.$t('relBoarding.reprocess.done', {
                    inseridos: (resultado && resultado.inseridos) || 0,
                    corrigidos: (resultado && resultado.corrigidos) || 0,
                }),
                'success'
            );
            if (this.hasLoadedReport) this.serverTableLoad();
        },
        pollReprocessamento(idProcesso) {
            this.clearReprocessamentoPoll();
            this.reprocessando = true;
            const deadline = Date.now() + REPROCESSAMENTO_TIMEOUT_MS;
            const pendingDeadline = Date.now() + REPROCESSAMENTO_PENDING_TIMEOUT_MS;
            const pollOnce = () => {
                if (Date.now() > deadline) return this.falhaReprocessamento(this.$t('relBoarding.reprocess.timeout'));
                if (this.reprocessamentoPollInFlight) return;
                this.reprocessamentoPollInFlight = true;
                apiController.request(apiController.endpoints.schedulerGetProcessoschedulerbyid, {
                    data: { id_processo: idProcesso },
                    config: { timeout: 30000 },
                    silent: true,
                    onSuccess: (statusRes) => {
                        this.reprocessamentoPollInFlight = false;
                        const pollData = statusRes.data || {};
                        if (pollData.erro) return this.falhaReprocessamento(pollData.mensagem);
                        const processo = pollData.processo || {};
                        if (processo.status === 'PENDING') {
                            if (Date.now() > pendingDeadline) {
                                this.falhaReprocessamento(this.$t('relBoarding.reprocess.notStarted'));
                            }
                            return;
                        }
                        if (processo.status === 'EXECUTING') return;
                        if (processo.status !== 'DONE') {
                            return this.falhaReprocessamento(this.mensagemFalhaSchedulerReprocessamento(processo));
                        }
                        this.concluiReprocessamento(pollData.resultado);
                    },
                    onError: (e) => {
                        const data = e.response && e.response.data;
                        this.falhaReprocessamento((data && (data.message || data.mensagem)) || e.message);
                    },
                });
            };
            this.reprocessamentoPollTimer = setInterval(pollOnce, REPROCESSAMENTO_POLL_MS);
            pollOnce();
        },
        embarqueTemCoordenada(item) {
            if (!item || item.lat == null || item.lng == null) return false;
            const lat = parseFloat(item.lat);
            const lng = parseFloat(item.lng);
            return !Number.isNaN(lat) && !Number.isNaN(lng);
        },
        embarqueParaMarcadorMapa(item) {
            return {
                id_embarque: item.id_embarque,
                id_linha: item.id_linha,
                lat: item.lat,
                lng: item.lng,
                cod_veiculo: item.cod_veiculo,
                dt_embarque_extenso: item.dt_embarque_extenso,
                nome_completo: item.nome_completo,
                cod_linha_veiculo: item.cod_linha_veiculo,
                cod_cerca: item.cod_cerca,
                nome_cerca: item.nome_cerca,
                autorizado: item.autorizado,
                sem_posicoes_janela: item.sem_posicoes_janela,
            };
        },
        limparRotasCercasSomenteMapa() {
            this.mapRotas = [];
            this.mapCercasGeojson = [];
            this.mapCercasCirculares = [];
            this.mapLinhasPlotadasNoMapa = [];
            if (this.mapModoMultiplosEmbarques) {
                this.atualizarMarcadoresVisiveisMapaEmbarques();
            }
        },
        removerRotasCercasLinhaMapa(idLinha) {
            const id = Number(idLinha);
            this.mapRotas = this.mapRotas.filter(
                (r) => Number(r._idLinhaMapaEmbarque) !== id
            );
            this.mapCercasGeojson = this.mapCercasGeojson.filter(
                (c) => Number(c._idLinhaMapaEmbarque) !== id
            );
            this.mapCercasCirculares = this.mapCercasCirculares.filter(
                (c) => Number(c._idLinhaMapaEmbarque) !== id
            );
        },
        /** Contagens no drawer usam a lista completa da plotagem "todos" (computed). */
        atualizarMarcadoresVisiveisMapaEmbarques() {
            if (!this.mapModoMultiplosEmbarques) return;
            const orig = this.mapEmbarqueMarkersOriginais || [];
            if (!orig.length) return;
            const ativos = this.mapLinhasPlotadasNoMapa || [];
            if (!ativos.length) {
                this.mapEmbarqueMarkers = orig.slice();
            } else {
                const set = new Set(ativos.map(Number));
                this.mapEmbarqueMarkers = orig.filter((m) => {
                    if (m.id_linha == null || Number(m.id_linha) === 0) {
                        return false;
                    }
                    return set.has(Number(m.id_linha));
                });
            }
            this.$nextTick(() => this.ajustarVisualizacaoMapaEmbarques());
        },
        contagemDrawerLinha(idLinha, campo) {
            if (idLinha == null) return 0;
            const bucket = this.contagensEmbarquesMapaPorLinha[Number(idLinha)];
            if (!bucket) return 0;
            return bucket[campo] || 0;
        },
        toggleDrawerLinhasEmbMap() {
            this.showingDrawerLinhasEmbMap = !this.showingDrawerLinhasEmbMap;
        },
        selectedLinhaDrawerMapaEmbarquesStyle(linha) {
            const id = linha && linha.id_linha;
            if (this.mapLinhasPlotadasNoMapa.indexOf(Number(id)) === -1) {
                return "border: 1px #4a4a4a40 solid; border-radius: 5px; margin: 2px 8px;";
            }
            return "background-color: #4a4a4a26; border: 2px #4a4a4a solid; border-radius: 5px; margin: 2px 8px;";
        },
        selectedLinhaDrawerMapaEmbarquesSubtitleStyle(linha) {
            if (this.mapLinhasPlotadasNoMapa.indexOf(Number(linha && linha.id_linha)) === -1) {
                return "";
            }
            return "font-weight: 600;";
        },
        async toggleLinhaMapaEmbarques(linha) {
            if (!linha || linha.id_linha == null) return;
            const id = Number(linha.id_linha);
            if (!id || Number.isNaN(id)) return;
            if (this.mapLinhaToggleLoadingId != null) return;
            const idx = this.mapLinhasPlotadasNoMapa.indexOf(id);
            if (idx !== -1) {
                this.removerRotasCercasLinhaMapa(id);
                this.mapLinhasPlotadasNoMapa.splice(idx, 1);
                this.atualizarMarcadoresVisiveisMapaEmbarques();
                return;
            }
            this.mapLinhaToggleLoadingId = id;
            try {
                await this.carregarRotasECercasLinha(id);
                if (this.mapLinhasPlotadasNoMapa.indexOf(id) === -1) {
                    this.mapLinhasPlotadasNoMapa.push(id);
                }
            } finally {
                this.mapLinhaToggleLoadingId = null;
            }
            this.atualizarMarcadoresVisiveisMapaEmbarques();
        },
        limparCamadasMapaEmbarque() {
            this.mapEmbarqueMarkers = [];
            this.mapEmbarqueMarkersOriginais = [];
            this.limparRotasCercasSomenteMapa();
        },
        async carregarRotasECercasLinha(idLinha) {
            const body = [idLinha];
            const routeColors = ["#1565C0", "#2E7D32", "#EF6C00", "#6A1B9A", "#C62828"];
            const cercaColors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#C62828"];
            const idLinhaTag = Number(idLinha);
            try {
                const [rotasRes, cercasRes] = await Promise.all([
                    apiController.request(apiController.endpoints.getRotasporlinha, { data: body, silent: true }),
                    apiController.request(apiController.endpoints.getCercasporlinha, { data: body, silent: true })]);
                const rotas = rotasRes.data || [];
                rotas.forEach((rota, idx) => {
                    if (!rota.geojson) return;
                    let gj = rota.geojson;
                    if (typeof gj === "string") {
                        try {
                            gj = JSON.parse(gj);
                        } catch (e) {
                            return;
                        }
                    }
                    const color = routeColors[idx % routeColors.length];
                    this.mapRotas.push({
                        ...rota,
                        _idLinhaMapaEmbarque: idLinhaTag,
                        geojson: gj,
                        style: { color, weight: 4, opacity: 0.85 },
                        options: {
                            onEachFeature: (feat, layer) => {
                                const name =
                                    (feat.properties && feat.properties.name) ||
                                    rota.nome_rota ||
                                    rota.cod_rota;
                                if (name) layer.bindPopup(String(name));
                            },
                        },
                    });
                });
                let cercaColorIdx = 0;
                (cercasRes.data || []).forEach((cerca) => {
                    if (cerca.cod_tipo_cerca === "POI") return;
                    const color = cercaColors[cercaColorIdx % cercaColors.length];
                    cercaColorIdx += 1;
                    if (Number(cerca.is_circular) === 1) {
                        const r = Number(cerca.raio_mts);
                        if (
                            cerca.lat_centro == null ||
                            cerca.lng_centro == null ||
                            Number.isNaN(r) ||
                            r <= 0
                        ) {
                            return;
                        }
                        this.mapCercasCirculares.push({
                            ...cerca,
                            _idLinhaMapaEmbarque: idLinhaTag,
                            _strokeColor: color,
                            _fillColor: color,
                        });
                        return;
                    }
                    if (!cerca.geojson) return;
                    let gj = cerca.geojson;
                    if (typeof gj === "string") {
                        try {
                            gj = JSON.parse(gj);
                        } catch (e) {
                            return;
                        }
                    }
                    this.mapCercasGeojson.push({
                        ...cerca,
                        _idLinhaMapaEmbarque: idLinhaTag,
                        geojson: gj,
                        style: {
                            color,
                            fillColor: color,
                            fillOpacity: 0.22,
                            weight: 2,
                        },
                        options: {
                            onEachFeature: (feat, layer) => {
                                const label =
                                    cerca.nome_cerca ||
                                    (feat.properties && feat.properties.name);
                                if (label) layer.bindPopup(String(label));
                            },
                        },
                    });
                });
            } catch (e) {
                EventBus.$emit("show-error", { error: e });
            }
        },
        async plot(item) {
            if (!this.embarqueTemCoordenada(item)) return;
            this.limparCamadasMapaEmbarque();
            this.mapModoMultiplosEmbarques = false;
            this.showingDrawerLinhasEmbMap = false;
            this.mapDrawerLinhasSearch = "";
            this.mapLinhasPlotadasNoMapa = [];
            this.mapLinhaToggleLoadingId = null;
            const latn = parseFloat(item.lat);
            const lngn = parseFloat(item.lng);
            const centroEmbarque = [latn, lngn];

            this.mapEmbarqueMarkers = [this.embarqueParaMarcadorMapa(item)];
            this.currentCenter = centroEmbarque;
            this.zoom = 15;
            this.rotasMapaVisible = true;
            this.cercasMapaVisible = true;
            this.markerEmbarqueVisible = true;
            this.embMapLeafletKey = 1 - this.embMapLeafletKey;
            this.dialogMap = true;
            await this.$nextTick();
            if (item.id_linha) {
                await this.carregarRotasECercasLinha(item.id_linha);
            }
            await this.$nextTick();
            this.ajustarVisualizacaoMapaEmbarques();
        },
        async plotTodosFiltrados() {
            this.loadingExport = true;
            let todos;
            try {
                todos = await this.loadItemsForExport();
            } catch (e) {
                EventBus.$emit("show-error", { error: e });
                this.loadingExport = false;
                return;
            }
            this.loadingExport = false;
            const comCoord = (todos || []).filter((e) =>
                this.embarqueTemCoordenada(e)
            );
            if (!comCoord.length) {
                EventBus.$emit("show-alert", {
                    mensagem: this.$t("relBoarding.plotAllNoCoordinates"),
                    tipo: "info",
                    duracao: 5000,
                });
                return;
            }
            this.limparCamadasMapaEmbarque();
            this.mapModoMultiplosEmbarques = true;
            this.showingDrawerLinhasEmbMap = false;
            this.mapDrawerLinhasSearch = "";
            this.mapLinhasPlotadasNoMapa = [];
            this.mapLinhaToggleLoadingId = null;
            const markers = comCoord.map((item) =>
                this.embarqueParaMarcadorMapa(item)
            );
            this.mapEmbarqueMarkersOriginais = markers.slice();
            this.mapEmbarqueMarkers = markers.slice();
            const first = comCoord[0];
            this.currentCenter = [
                parseFloat(first.lat),
                parseFloat(first.lng)];
            this.zoom = 14;
            this.rotasMapaVisible = true;
            this.cercasMapaVisible = true;
            this.markerEmbarqueVisible = true;
            this.embMapLeafletKey = 1 - this.embMapLeafletKey;
            this.dialogMap = true;
            await this.$nextTick();
            this.ajustarVisualizacaoMapaEmbarques();
        },
        closeDialogMapa() {
            this.dialogMap = false;
        },
        /** Estado do mapa ao fechar (também via watch dialogMap). Idempotente. */
        resetEstadoMapaEmbarque() {
            this.limparCamadasMapaEmbarque();
            this.mapModoMultiplosEmbarques = false;
            this.showingDrawerLinhasEmbMap = false;
            this.mapDrawerLinhasSearch = "";
            this.mapLinhasPlotadasNoMapa = [];
            this.mapLinhaToggleLoadingId = null;
            this.zoom = 12;
            this.currentCenter = this.center || [-22.88746, -43.29185];
            this.map = null;
        },
        centralizarMapaNoEmbarque(centroEmbarque) {
            this.currentCenter = centroEmbarque;
            this.onMapPlotagemResize();
            const mo = this.$refs.mapPlotagem && this.$refs.mapPlotagem.mapObject;
            if (mo) {
                mo.setView(centroEmbarque, this.zoom, { animate: false });
            }
        },
        ajustarVisualizacaoMapaEmbarques() {
            this.$nextTick(() => {
                const mo = this.$refs.mapPlotagem && this.$refs.mapPlotagem.mapObject;
                if (!mo) return;
                const pts = (this.mapEmbarqueMarkers || []).filter((m) =>
                    this.embarqueTemCoordenada(m)
                );
                if (!pts.length) return;
                if (pts.length === 1) {
                    const m = pts[0];
                    this.centralizarMapaNoEmbarque([
                        parseFloat(m.lat),
                        parseFloat(m.lng)]);
                    return;
                }
                const bounds = L.latLngBounds(
                    L.latLng(parseFloat(pts[0].lat), parseFloat(pts[0].lng))
                );
                for (let i = 1; i < pts.length; i++) {
                    bounds.extend(
                        L.latLng(parseFloat(pts[i].lat), parseFloat(pts[i].lng))
                    );
                }
                mo.fitBounds(bounds, { animate: false, maxZoom: 16, padding: [40, 40] });
                mo.invalidateSize();
            });
        },
        onMapPlotagemReady() {
            this.onMapPlotagemResize();
        },
        onMapPlotagemResize() {
            const mo = this.$refs.mapPlotagem && this.$refs.mapPlotagem.mapObject;
            if (mo) {
                mo.invalidateSize();
            }
        },
        /**
         * Mesma regra de cor da coluna Autorizado: verde (1), laranja (2), vermelho (demais).
         * Usa cores do tema Vuetify quando existirem (green / orange / red).
         */
        corMarcadorAutorizado(autorizado) {
            const nome =
                autorizado == 1 ? "green" : autorizado == 2 ? "orange" : "red";
            const theme =
                this.$vuetify &&
                this.$vuetify.theme &&
                this.$vuetify.theme.currentTheme;
            if (theme && theme[nome]) {
                return theme[nome];
            }
            const fallback = { green: "#4CAF50", orange: "#FB8C00", red: "#F44336" };
            return fallback[nome];
        },
        getIconEmbarqueMapa(reg) {
            const a = Number(reg && reg.autorizado);
            const key = a === 1 ? "1" : a === 2 ? "2" : "other";
            const cached = this._mapIconByAutorizado && this._mapIconByAutorizado[key];
            if (cached) {
                return cached;
            }
            const fill = this.corMarcadorAutorizado(reg && reg.autorizado);
            const w = 28;
            const h = 36;
            const html =
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 46" width="${w}" height="${h}" aria-hidden="true">` +
                    `<path d="M18 1 C8.6 1 1 8.6 1 18 C1 28 18 45 18 45 C18 45 35 28 35 18 C35 8.6 27.4 1 18 1 Z" ` +
                          `fill="${fill}" stroke="#ffffff" stroke-width="2" stroke-linejoin="round"/>` +
                    `<circle cx="18" cy="17" r="8.5" fill="#ffffff"/>` +
                    `<g transform="translate(10 9) scale(0.667)">` +
                        `<path d="${mdiAccount}" fill="${fill}"/>` +
                    `</g>` +
                `</svg>`;
            const icon = L.divIcon({
                className: "relembarques-mdi-marker",
                html,
                iconSize: [w, h],
                iconAnchor: [w / 2, h - 2],
                popupAnchor: [0, -(h - 2)],
            });
            if (!this._mapIconByAutorizado) {
                this._mapIconByAutorizado = Object.create(null);
            }
            this._mapIconByAutorizado[key] = icon;
            return icon;
        },
        latLng(lat, lng) {
            const fallback = L.latLng(-22.88746, -43.29185);
            if (lat == null || lng === null) return fallback;
            const la = typeof lat === "number" ? lat : parseFloat(String(lat).trim().replace(",", "."));
            const ln = typeof lng === "number" ? lng : parseFloat(String(lng).trim().replace(",", "."));
            if (Number.isNaN(la) || Number.isNaN(ln)) return fallback;
            if (la === 0 && ln === 0) return fallback;
            return L.latLng(la, ln);
        },
        async exportPDF(div) {
            if (!div) {
                return;
            }
            const title = String(this.$tc("relPlot.self", 1) || "plotagem").replace(
                /\s+/g,
                "_"
            );
            this.exportingMapPdf = true;
            this.onMapPlotagemResize();
            await this.$nextTick();
            await new Promise((r) => setTimeout(r, 250));
            div.classList.add("emb-map-pdf-exporting");
            const dialogEl = div.closest(".v-dialog");
            const prevTransform = dialogEl ? dialogEl.style.transform : "";
            if (dialogEl) {
                dialogEl.style.transform = "none";
            }
            try {
                const dataUrl = await domtoimage.toPng(div, { bgcolor: "#ffffff" });
                const img = new Image();
                img.src = dataUrl;
                await new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = reject;
                });
                const doc = new jsPDF({
                    orientation: "l",
                    format: "a4",
                });
                doc.addImage(dataUrl, "PNG", 5, 5, 285, 195);
                const date = new Date();
                const filename =
                    `${title}_` +
                    date.getFullYear() +
                    ("0" + (date.getMonth() + 1)).slice(-2) +
                    ("0" + date.getDate()).slice(-2) +
                    ("0" + date.getHours()).slice(-2) +
                    ("0" + date.getMinutes()).slice(-2) +
                    ("0" + date.getSeconds()).slice(-2) +
                    ".pdf";
                doc.save(filename);
            } catch (error) {
                console.error(error);
                EventBus.$emit("show-alert", {
                    mensagem: this.$t("relBoarding.exportMapPdfError"),
                    tipo: "error",
                });
            } finally {
                div.classList.remove("emb-map-pdf-exporting");
                if (dialogEl) {
                    dialogEl.style.transform = prevTransform;
                }
                this.exportingMapPdf = false;
            }
        },
        // onEmpresaChanged() {
        //     if (this.idEmpresaSelected) {
        //         this.clientesSelect = this.clientes.filter((c) => c.id_empresa == this.idEmpresaSelected);
        //     } else {
        //         this.clientesSelect = this.clientes;
        //     }
        //     this.populaVeiculosSelect();
        // }, 
        // onClienteChanged() {
        //     if (this.idClienteSelected) {
        //         this.passageirosSelect = this.passageiros.filter((p) => p.id_cliente == this.idClienteSelected);
        //     } else {
        //         this.passageirosSelect = this.passageiros;
        //     }
        // },
    }
}
</script>

<style>
.relembarques-mdi-marker {
    background: transparent !important;
    border: none !important;
    filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.45));
    transition: transform 0.12s ease-out, filter 0.12s ease-out;
    transform-origin: 50% 100%;
    will-change: transform;
}
.relembarques-mdi-marker:hover {
    transform: translateY(-2px) scale(1.06);
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.55));
    z-index: 1000 !important;
}
/* drop-shadow / transform quebram o clone do mapa no dom-to-image */
.emb-map-pdf-exporting .relembarques-mdi-marker {
    filter: none !important;
    transform: none !important;
}
.emb-map-pdf-exporting .emb-map-pdf-hide {
    display: none !important;
}
.emb-map-dialog-root {
    position: relative;
    overflow: visible;
}
/* Corpo do mapa: o drawer fica contido aqui, abaixo da toolbar do diálogo (evita corte no topo). */
.emb-map-dialog-body {
    position: relative;
    height: 75vh;
    min-height: 280px;
}
.emb-map-dialog-card-text {
    height: 100%;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}
.emb-map-linhas-drawer {
    width: 30% !important;
    min-width: 280px !important;
    max-width: 440px !important;
    z-index: 5000 !important;
    top: 0 !important;
    height: 100% !important;
    max-height: 100% !important;
}
.emb-map-linhas-drawer-inner {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow: hidden;
}
.emb-map-linhas-drawer-toolbar {
    flex-shrink: 0;
}
.emb-map-linhas-drawer-search,
.emb-map-linhas-drawer-actions {
    flex-shrink: 0;
}
.emb-map-linhas-drawer-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto !important;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    align-self: stretch;
    width: 100%;
}
.emb-map-linhas-drawer .v-navigation-drawer__content {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: stretch !important;
    justify-content: flex-start !important;
}
.emb-map-linhas-drawer-list .emb-map-linhas-drawer-list-item {
    align-items: flex-start;
}
.emb-map-linhas-drawer-list .v-list-item__content {
    align-items: flex-start;
    text-align: left;
}
</style>
